import { parseSanitizedHtml } from "@/utils/sanitizeHtml";
import { useEffect } from "react";
import RightTimeApi from "@/API";
import Helpers from "../Helpers";
import { clearTakerTestIdentity } from "@/utils/takerTestStorage";

// const staticContent = {
//   eng: {
//       defaultContent: "Thank you for taking your time to complete the questionnaire!",
//   },
//   esp: {
//       defaultContent: "¡Gracias por tomarte el tiempo para completar el cuestionario!",
//   }
// };

export default function Done(props) {
   const { sectionData } = props;
   const currentSection = sectionData?.currentSection;
   const contentObj = Helpers.getSectionContent(currentSection, sectionData?.lang);
   const content = Helpers.getSectionHtmlValue(contentObj, "instructions");

   useEffect(() => {
      sectionData?.registerSection?.();
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentSection?.name]);

   async function getContentAsync() {
      const testData = sectionData?.testState;
      if (testData?.id) {
         const resp = await RightTimeApi.getAsync("/Done?testId=" + testData.id);
         if (resp && resp.ok) {
            window.sessionStorage.clear();
         }
      }
   }

   useEffect(() => {
      clearTakerTestIdentity();
      getContentAsync();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   return (
      <div className="page done">
         <span className="contentContainer">
            {parseSanitizedHtml(typeof content === "string" ? content : "")}
         </span>
      </div>
   );
}